import Gamer from "./Gamer"

class PlayerGamer extends Gamer {

}

export default PlayerGamer
